import { zodResolver } from "@hookform/resolvers/zod";
import {
  type FieldValues,
  type Path,
  useForm,
  type UseFormProps,
  type UseFormReturn,
} from "react-hook-form";
import type { z } from "zod";

import { ApiRequestError } from "./apiClient";

/**
 * Form sistemi tek girişi (S10): react-hook-form + zodResolver.
 * Hata mesajları @closer/shared şemalarında Türkçe tanımlıdır; UI metin uydurmaz (kriter 7).
 * Girdi/çıktı tipleri ayrı tutulur: .default()/.transform() içeren şemalarda (zod v4 +
 * resolvers v5) form değerleri şema GİRDİ tipi, submit değerleri ÇIKTI tipidir.
 */
export function useZodForm<TInput extends FieldValues, TOutput extends FieldValues>(
  schema: z.ZodType<TOutput, TInput>,
  props?: Omit<UseFormProps<TInput, unknown, TOutput>, "resolver">,
): UseFormReturn<TInput, unknown, TOutput> {
  return useForm<TInput, unknown, TOutput>({
    resolver: zodResolver(schema),
    ...props,
  });
}

/**
 * Sunucudan dönen alan hatalarını (S1 fields[]) form alanlarına işler.
 * Alan-dışı hatalar toast katmanının işidir; burada yok sayılır.
 */
export function applyServerErrors<TFieldValues extends FieldValues, TContext, TTransformedValues>(
  form: UseFormReturn<TFieldValues, TContext, TTransformedValues>,
  error: unknown,
): void {
  if (!(error instanceof ApiRequestError) || !error.fields) return;
  for (const fieldError of error.fields) {
    form.setError(fieldError.field as Path<TFieldValues>, {
      type: "server",
      message: fieldError.message,
    });
  }
}
